export default __webpack_public_path__ + "static/work-131101a7848aa6ef9534cb4a799f4347.jpg";